import router from './router'
import './routerBeforeGuard'

export default router
